import { render, staticRenderFns } from "./TicketHistoryView.vue?vue&type=template&id=c9ac6ab6&scoped=true&"
import script from "./TicketHistoryView.vue?vue&type=script&lang=js&"
export * from "./TicketHistoryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9ac6ab6",
  null
  
)

export default component.exports